import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, Observable } from 'rxjs';
import { PITEventService, UtilsMisc } from '@pit/core';
import { EntityDataServiceAccessorService } from '@pit/core-data';
import { EntityStoreFacade } from '@pit/core-store';
import { IDtoDepot } from '@pit/frontend-model';
import { DtoDepotStoreFactory } from './dto.depot.store.factory';
import { IDtoDepotEntityDataService } from '../../module.data/services/interfaces/dto.depot.entity.data.service.interface';

@Injectable({
    providedIn: 'root'
})
export class DtoDepotStoreFacade extends EntityStoreFacade<IDtoDepot> {

    constructor(store: Store<IDtoDepot>, dataServiceAccessor: EntityDataServiceAccessorService, eventService: PITEventService) {
        super(DtoDepotStoreFactory.instance, store, 'DtoDepot', dataServiceAccessor, eventService);
    }

    public loadDepotsForMandator$(mandatorId: number): void {
        this.store.dispatch(this.entityStoreFactory.getAction('get.by.mandator')({ mandatorId: mandatorId }));
    }

    public async loadDepotsForMandatorAsync(mandatorId: number): Promise<IDtoDepot[]> {
        let result: IDtoDepot[] = null;
        try {
            const queryResult: IDtoDepot[] = await (this.dataServiceAccessor.getEntityDataService<IDtoDepot>(this.entityStoreFactory.dataAccessName.toLowerCase()) as IDtoDepotEntityDataService).getDepotsForMandatorAsync(mandatorId);
            this.clear();
            if ((UtilsMisc.isNullOrUndefined(queryResult) === false) && (queryResult.length > 0)) {
                result = queryResult;
                this.upsertItemsToStore(result);
            }
        } catch (error) {
        } finally {
        }

        return result;
    }

}
